module.exports = __webpack_public_path__ + "img/Jump Casting125.944e734c.jpg";